/*
  Smooth scroll — home page and product pages.
  Mouse-wheel / trackpad scrolling glides to a stop with a soft inertia (the page
  eases towards where the wheel sent it, like Apple's / Lenis-style smooth scroll)
  instead of jumping in steps. Touch screens keep their own native momentum.

  - Only the page itself is smoothed: wheeling over something that scrolls on its
    own (a drawer, a popup list, a table) is left to the browser, and so are
    sideways / shift-wheel scrolls (carousels) and ctrl-wheel zoom.
  - Keyboard, scrollbar dragging, anchor links and scripts calling window.scrollTo
    keep working: if anything else moves the page, the glide stops and picks up
    from there on the next wheel tick.
  - Off with prefers-reduced-motion, on touch-only devices, while a popup locks the
    page (overflow: hidden), and inside [data-smooth-scroll="off"].
*/
(function () {
  if (!window.requestAnimationFrame) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var EASE = 0.1;                 /* share of the remaining distance covered per 60fps frame */
  var FRAME = 1000 / 60;
  var LINE = 40;                  /* px per line for line-based wheels (Firefox) */

  var html = document.documentElement;
  var target = 0;                 /* where the wheel wants the page to be */
  var current = 0;                /* where the glide has got to (fractional) */
  var lastSet = 0;                /* scrollY right after our own last scrollTo */
  var running = false;
  var lastTime = 0;
  var savedBehavior = '';

  function maxScroll() {
    return Math.max(0, (document.scrollingElement || html).scrollHeight - window.innerHeight);
  }

  function locked() {
    var b = document.body;
    return getComputedStyle(html).overflowY === 'hidden' ||
           (b && getComputedStyle(b).overflowY === 'hidden');
  }

  /* Is there something under the pointer that scrolls on its own in this direction? */
  function innerScroller(node, dy) {
    for (; node && node !== document.body && node !== html; node = node.parentElement) {
      if (node.scrollHeight <= node.clientHeight + 1) continue;
      var cs = getComputedStyle(node);
      if (cs.overflowY !== 'auto' && cs.overflowY !== 'scroll') continue;
      if (dy > 0 ? node.scrollTop + node.clientHeight < node.scrollHeight - 1 : node.scrollTop > 0) return true;
      if (cs.overscrollBehaviorY === 'contain' || cs.overscrollBehaviorY === 'none') return true;
    }
    return false;
  }

  function stop() {
    running = false;
    html.style.scrollBehavior = savedBehavior;
  }

  function frame(now) {
    if (!running) return;
    /* Something else moved the page (keyboard, scrollbar, anchor, script): follow it. */
    if (Math.abs(window.scrollY - lastSet) > 2) { stop(); return; }
    var dt = Math.max(0, Math.min(now - lastTime, 100));
    lastTime = now;
    current += (target - current) * (1 - Math.pow(1 - EASE, dt / FRAME));
    if (Math.abs(target - current) < 0.5) current = target;
    window.scrollTo(0, current);
    lastSet = window.scrollY;
    if (current === target) { stop(); return; }
    requestAnimationFrame(frame);
  }

  window.addEventListener('wheel', function (e) {
    if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var dy = e.deltaY;
    if (!dy || Math.abs(e.deltaX) > Math.abs(dy)) return;
    if (e.deltaMode === 1) dy *= LINE;
    else if (e.deltaMode === 2) dy *= window.innerHeight;
    var el = e.target && e.target.nodeType === 1 ? e.target : null;
    if (el && el.closest('[data-smooth-scroll="off"]')) return;
    if (locked() || innerScroller(el, dy)) return;

    e.preventDefault();
    if (!running) {
      current = target = lastSet = window.scrollY;
      running = true;
      lastTime = performance.now();
      /* A CSS `scroll-behavior: smooth` would turn every step into its own animation. */
      savedBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      requestAnimationFrame(frame);
    }
    target = Math.max(0, Math.min(maxScroll(), target + dy));
  }, { passive: false });
})();
